import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../url';
import 'swiper/swiper-bundle.css';
import Profile from '../Profile/Profile';
import './Navbar.css';
import Favoritos from '../Favoritos/Favoritos';
import { useCatalogData } from '../CatalogData/CatalogDataProvider';

const fallbackLogo = '/brand/inksu-logo-horizontal.png';

export default function Navbar({ navigation = null }) {
    const { tiendaPrincipal, ensureTienda } = useCatalogData();
    const [isOpen, setIsOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cargarBanners();
        ensureTienda().catch(() => {});
    }, [ensureTienda]);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const bannersSeleccionados = Array.isArray(data.banner)
                    ? data.banner.filter(banner => banner.seleccion === 'Si')
                    : [];
                setImages(bannersSeleccionados.map(banner => banner.imagen));
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error);
                setLoading(false);
            });
    };

    return (
        <header className="public-header">
            <div className="public-header__bar">
                <Anchor to="/" className="logo" aria-label="Ir al inicio de INK-SU">
                    <img
                        src={tiendaPrincipal?.imagen1 || fallbackLogo}
                        alt={`${tiendaPrincipal?.nombre || 'INK-SU'} - logo`}
                        decoding="async"
                    />
                    <span className="deColumnNav">
                        <strong className="public-header__name">{tiendaPrincipal?.nombre || 'INK-SU'}</strong>
                        <small>{tiendaPrincipal?.eslogan || 'Insumos para tecnología'}</small>
                    </span>
                </Anchor>

                <div className="public-header__actions">
                    <Favoritos />
                    <button
                        type="button"
                        className={`public-header__toggle ${isOpen ? 'open' : ''}`}
                        onClick={() => setIsOpen(current => !current)}
                        aria-label={isOpen ? 'Cerrar información de la tienda' : 'Abrir información de la tienda'}
                        aria-expanded={isOpen}
                        aria-controls="menu-principal-inksu"
                    >
                        <span />
                        <span />
                        <span />
                    </button>
                </div>
            </div>

            {navigation}

            <Modal
                isOpen={isOpen}
                onRequestClose={() => setIsOpen(false)}
                className="modalNav"
                overlayClassName="overlay"
                contentLabel="Información de la tienda INK-SU"
            >
                <div className="modalNav-content" id="menu-principal-inksu">
                    {loading ? (
                        <div className="loadingBannerFondo" />
                    ) : (
                        <>
                            {images.length > 0 ? (
                                <div className="fondo">
                                    <img src={images[0]} alt="Banner promocional de INK-SU" loading="lazy" decoding="async" />
                                </div>
                            ) : (
                                <div className="space" />
                            )}
                            <Profile />
                        </>
                    )}
                </div>
            </Modal>
        </header>
    );
}
